/**
 * Stolen from https://github.com/vercel/next.js/discussions/49465
 */

"use client"

import { useEffect, useState } from "react"

const getHash = (): string =>
  typeof window !== "undefined" ? decodeURIComponent(window.location.hash.replace("#", "")) : ""

/**
 * Retrieve the hash from the url after the hook is mounted to avoid hydration issues.
 * Reason: the hash is no more available in new routing hooks (it was in `asPath`).
 *
 * @returns The hash without the hashbang prefix
 */
export const useHash = (): string => {
  const [hash, setHash] = useState(getHash())
  const [isClient, setIsClient] = useState(false)

  useEffect(() => {
    setIsClient(true)

    const handleHashChange = (): void => {
      setHash(getHash())
    }

    window.addEventListener("hashchange", handleHashChange)

    return () => {
      window.removeEventListener("hashchange", handleHashChange)
    }
  }, [])

  return isClient ? hash : ""
}
